import React, { useEffect, useState } from "react";
import { useLockContext } from "../../context/LockContext";
import Navbar from "../../Layouts/Navbar/Navbar";
import PageInfoAndActionBar from "../../Layouts/PageInfoAndActionBar";
import ButtonActionIcon from "../../components/BuilderComponents/ButtonActionIcon";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import "./Lock.css";
import { TryAgainMessage } from "../Screen/ScreenSection";
import BuilderTable from "../../Layouts/BuilderTable";
import Input from "../../components/FormComponents/Input";
import HeaderModes from "../../Layouts/Navbar/HeaderModes";
import Button from "../../components/FormComponents/Button";
import { toastSuccess } from "../../utils/toastUtils";

const LockSection = () => {
  const { fetchAllLocks, allLockData, setAllLockData } = useLockContext();

  const [selectedLocks, setSelectedLocks] = useState([]);
  const [isError, setIsError] = useState(false);

  const deleteLock = async (id) => {
    try {
      const { message } = await axiosInstance.delete(`/app/fd/lock/${id}`);
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleSingleDelete = async (id) => {
    try {
      await deleteLock(id);
      setAllLockData(allLockData.filter((lock) => lock.type_id !== id));
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleCheckboxChange = (lock) => {
    if (selectedLocks.find((l) => l.type_id === lock.type_id)) {
      setSelectedLocks(selectedLocks.filter((selectedLock) => selectedLock.type_id !== lock.type_id));
    } else {
      setSelectedLocks([...selectedLocks, lock]);
    }
  };

  const handleSelectedDelete = async () => {
    try {
      const idArray = selectedLocks.map((lock) => lock.type_id);
      for (const id of idArray) {
        await deleteLock(id);
      }
      setAllLockData(allLockData.filter((lock) => !idArray.includes(lock.type_id)));
      setSelectedLocks([]);
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleAllDelete = async () => {
    try {
      if (allLockData) {
        await axiosInstance.delete(`app/releasealllock`);
        setAllLockData({});
      }
    } catch (error) {
      console.error("API call failed", error);
    }
  };

  const initialFetching = async () => {
    setIsError(false);
    try {
      fetchAllLocks();
    } catch (error) {
      setIsError(true);
    }
  };

  useEffect(() => {
    initialFetching();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    { key: "type_name", header: "LockOn" },
    { key: "type", header: "BlockType" },
    { key: "user_info", header: "LockBy" }
  ];

  const customColumns = [
    {
      header: "Select",
      render: (lock) => (
        <Input
          type="checkbox"
          onChange={() => handleCheckboxChange(lock)}
          checked={!!selectedLocks.find((l) => l.type_id === lock.type_id)}
        />
      )
    },
    {
      header: "Action",
      render: (lock) => <ButtonActionIcon type="delete" size="xsm" onClick={() => handleSingleDelete(lock.type_id)} />
    }
  ];

  return (
    <section className="main_section">
      {isError ? (
        <TryAgainMessage retryFunction={initialFetching} />
      ) : (
        <>
          <div className="d_flex">
            <HeaderModes />
            <div className={`w_100`}>
              <PageInfoAndActionBar pagePath={`Lock`} currentConfig={[]} />
            </div>
          </div>
          <div className="d_flex">
            <Navbar />
            <div className="lock_main_page page_main_section w_75">
              <div className="d_flex justify_end gap_2 py_3">
                <Button className="btn btn_red" disabled={selectedLocks.length === 0} onClick={handleSelectedDelete}>
                  Delete Selected
                </Button>
                <Button
                  className="btn btn_red_outline"
                  disabled={!allLockData || allLockData.length === 0}
                  onClick={handleAllDelete}
                >
                  Delete All
                </Button>
              </div>
              <BuilderTable
                columns={columns}
                data={allLockData}
                customColumns={customColumns}
                columnStyles={{ Actions: { display: "flex", gap: "4px" } }}
                noDataMessage="No Users Found"
              />
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default LockSection;
